import { Button } from '@blueprintjs/core';
import { navigateToPageInNewTab } from '../../utils/navegationFunctions';
import { NavigationHook } from '../hooks/NavegationHook';


function CustomNavButton({icon, text = "", pageID}) {

  const [currentPage, navigate] = NavigationHook();

  return(
  <div>
      <Button icon={icon} 
                    text={text}                  
                    className={`bp3-minimal customNavButton ${currentPage === pageID && "selected"}`}                  
                    onClick={(_) =>  {navigate(pageID)}}
                    onContextMenu={(event) => {event.preventDefault();navigateToPageInNewTab(pageID)}}/>
  </div>)
}

export function CustomActionNavButton({icon, text = "", onClick, title}) {

  return(<Button icon={icon} 
                 text={text} 
                 className={`bp3-minimal customNavButton`}                  
                 onClick={onClick}
                 title={title}/>)
}

export default CustomNavButton;